<template>
  <section v-if="hotel" id="hotel" class="hotel-section">
    <v-container>
      <p class="section-kicker">Our Las Vegas Home Base</p>
      <h2>Where We Stay</h2>
      <article class="hotel-card">
        <div class="hotel-icon" aria-hidden="true">
          <v-icon>mdi-office-building-marker-outline</v-icon>
        </div>
        <div class="hotel-copy">
          <span>{{ hotel.label }}</span>
          <h3>{{ hotel.name }}</h3>
          <p>{{ hotel.description }}</p>
          <ul v-if="hotel.highlights && hotel.highlights.length">
            <li v-for="highlight in hotel.highlights" :key="highlight">
              <v-icon small>mdi-check-circle-outline</v-icon>{{ highlight }}
            </li>
          </ul>
        </div>
      </article>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'RecurringHotelCard',
  props: { hotel: { type: Object, default: null } },
};
</script>

<style scoped>
.hotel-section { background: #0b0b0b; border-top: 1px solid #242424; padding: 72px 0; scroll-margin-top: 68px; }
.section-kicker { color: #e23232; font-family: "Oswald", sans-serif; font-weight: 800; margin: 0 0 7px; text-transform: uppercase; }
h2 { color: #fff; font-family: "Oswald", sans-serif; font-size: clamp(2.2rem, 5vw, 3.2rem); margin: 0 0 28px; }
.hotel-card { align-items: stretch; background: linear-gradient(120deg, #17120d, #111); border: 1px solid #3b3024; border-radius: 12px; display: grid; grid-template-columns: 180px 1fr; max-width: 900px; overflow: hidden; }
.hotel-icon { align-items: center; background: radial-gradient(circle, #342515, #130f0a); display: flex; justify-content: center; min-height: 260px; }
.hotel-icon .v-icon { color: #f0b13c; font-size: 5rem; }
.hotel-copy { padding: 34px; }
.hotel-copy > span { color: #f0b13c; font-size: .75rem; font-weight: 900; text-transform: uppercase; }
h3 { color: #fff; font-family: "Oswald", sans-serif; font-size: 2rem; margin: 7px 0 13px; }
.hotel-copy > p { color: #c0c0c0; line-height: 1.65; margin: 0; max-width: 650px; }
ul { display: flex; flex-wrap: wrap; gap: 10px 18px; list-style: none; margin: 22px 0 0; padding: 0; }
li { align-items: center; color: #ddd; display: flex; font-size: .84rem; gap: 6px; }
li .v-icon { color: #e23232; }
@media (max-width: 640px) { .hotel-card { grid-template-columns: 1fr; } .hotel-icon { min-height: 130px; } .hotel-copy { padding: 26px; } }
</style>
